import { DateTime } from 'luxon';

export const defaultTimeFrameOptions: TimeframeOption[] = [
  { type: 'relative', days: 7, label: 'Previous 7 days' },
  { type: 'relative', days: 14, label: 'Previous 14 days' },
  { type: 'relative', days: 30, label: 'Previous 30 days' },
  { type: 'relative', days: 90, label: 'Previous 90 days' },
  { type: 'relative', days: 180, label: 'Previous 180 days' },
  { type: 'relative', days: 365, label: 'Previous year' },
];

export type TimeframeOption =
  | { type: 'relative'; days: number; label: string }
  | { type: 'absolute'; minDate: string; maxDate: string; label: string };

const generateYearTimeFrameOptions = (): TimeframeOption[] => {
  const now = DateTime.now();
  const options: TimeframeOption[] = [];

  // Add current year and two prior years
  for (let i = 0; i < 3; i += 1) {
    const year = now.year - i;
    const yearStart = DateTime.fromObject({ year, month: 1, day: 1 });
    const yearEnd = DateTime.fromObject({ year, month: 12, day: 31 });

    options.push({
      type: 'absolute',
      minDate: yearStart.toISODate() || '',
      maxDate: yearEnd.toISODate() || '',
      label: `Year ${year}`,
    });
  }

  // Add current month and two prior months
  for (let i = 0; i < 3; i += 1) {
    const monthDate = now.minus({ months: i });
    const monthStart = monthDate.startOf('month');
    const monthEnd = monthDate.endOf('month');

    options.push({
      type: 'absolute',
      minDate: monthStart.toISODate() || '',
      maxDate: monthEnd.toISODate() || '',
      label: monthDate.toFormat('MMMM yyyy'),
    });
  }

  return options;
};

export const defaultProjectOptions: TimeframeOption[] = generateYearTimeFrameOptions();
